<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="task-tracking-details">
  <div class="task-header mb-3">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h3 class="mb-0">Task #{{ task()?.series }}</h3>
      <h3 class="mb-0 color-primary">{{ 'task.statusEnum.' + task()?.status | translate }}</h3>
    </div>
    @if (task()?.lastModifiedAt) {
      <div class="task-updated-at small color-gray">
        <span class="fw-medium">{{ 'dispatcher.tasks.updatedAt' | translate }}:</span>
        <span>{{ task()?.lastModifiedAt | wellDate:'yyyy-MM-dd HH:mm' }}</span>
      </div>
    }
  </div>

  @if (task()?.pickupCheckpoint; as pickupCheckpoint) {
    <well-task-checkpoint-tracking-details
      [checkpoint]="pickupCheckpoint"
      [type]="TaskCheckpointType.PICKUP"
    ></well-task-checkpoint-tracking-details>
  }

  @for (deliveryCheckpoint of task()?.deliveryCheckpoints; track deliveryCheckpoint.uuid) {
    <well-task-checkpoint-tracking-details
      [checkpoint]="deliveryCheckpoint"
      [type]="TaskCheckpointType.DELIVERY"
    ></well-task-checkpoint-tracking-details>
  }

  @if (task()?.returnCheckpoint; as returnCheckpoint) {
    <well-task-checkpoint-tracking-details
      [checkpoint]="returnCheckpoint"
      [type]="TaskCheckpointType.RETURN"
    ></well-task-checkpoint-tracking-details>
  }
</div>
